import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'layout-auth',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './auth-layout.component.html',
  styles: `
    :host(layout-auth) {
      display: contents;

      main {
        display: block;
        width: 100vw;
        min-height: 100vh;
        overflow: hidden;
        background-color: #0b0a14;
        background-image: url('/assets/images/backgrounds/fondo.png');
        background-repeat: no-repeat;
        background-position: center top;
        background-size: cover;
      }
    }
  `,
})
export class AuthLayoutComponent {}